var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomInS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.25H14.5V11.75H12.25V14H10.75V11.75H8.5V10.25H10.75V8H12.25V10.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 18.939L19.439 20L15.888 16.449C14.688 17.418 13.163 18 11.5 18C7.634 18 4.5 14.866 4.5 11C4.5 7.134 7.634 4 11.5 4C15.366 4 18.5 7.134 18.5 11C18.5 12.663 17.918 14.188 16.949 15.389L20.5 18.939ZM17 11C17 7.967 14.533 5.5 11.5 5.5C8.467 5.5 6 7.967 6 11C6 14.033 8.467 16.5 11.5 16.5C14.533 16.5 17 14.033 17 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomInS);
export default __webpack_public_path__ + "static/media/zoom-in-S.227371244816f93c0b73e34524c3efeb.svg";
export { ForwardRef as ReactComponent };